import React from 'react';
import QueryParamsUtil from '../../reverb-js-common/query_params_util';

import CuratedSet from './curated_set';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { get } from 'lodash';

interface Props {
  curatedSet: CuratedSet;
  linkParams?: Record<string, any>;
}

export default class CuratedSetCard extends React.Component<Props, null> {
  buildImagePath() {
    const { image } = this.props.curatedSet;
    if (!image) { return null; }

    return get(image, '_links.small.href');
  }

  href() {
    const fullUrl = new URL(this.props.curatedSet._links.self.href);
    if (this.props.linkParams) {
      const queryString = QueryParamsUtil.queryParamsForUrl(this.props.linkParams);
      return `${fullUrl.pathname}${queryString}`;
    }

    return fullUrl.pathname;
  }

  render() {
    return (
      <div className="curated-set-card curated-set-card--basic">
        <CoreLink
          to={this.href()}
          trackName="CuratedSetRow"
          entityId={this.props.curatedSet.id.toString()}
        >
          <div className="curated-set-card__image">
            <div className="curated-set-card__image__inner"
              style={{ backgroundImage: `url(${this.buildImagePath()})` }}
            />
          </div>
          <div className="curated-set-card__text">
            <div className="curated-set-card__text__inner">
              <div className="curated-set-card__title">
                {this.props.curatedSet.name}
              </div>
            </div>
          </div>
        </CoreLink>
      </div>
    );
  }
}
